import generate from 'nanoid/non-secure/generate'

const shortid = {
  generate: () => generate("0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-", 8)
}

export default shortid